module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='" + (['image-wrapper', "" + ($e($c((!this.asset.get("persisted") ? "placeholder maskable" : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
      if (this.asset.get("persisted")) {
        $o.push("  <img src='" + ($e($c(this.asset.get("small")))) + "'>\n  <span class='icon icon-x js-delete'></span>");
      }
      if (this.confirmDelete) {
        $o.push("  <div class='delete-overlay delete-queue'>\n    <div class='delete-confirmation'>\n      <div class='delete-content-wrapper'>\n        <div class='delete-content'>\n          Are you sure?\n          <a class='js-cancel-delete pipe-separated'>Cancel</a>\n          <a class='js-confirm-delete pipe-separated'>Delete</a>\n        </div>\n      </div>\n    </div>\n  </div>");
      }
      $o.push("</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/asset.js.hamlc
// module id = 1520
// module chunks = 18